import styled from '@emotion/styled'
import { Box } from '@mui/material'

import { shadow } from '@f-fertighaus/applications/Next/config/styles'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { ClientOnly } from '@f-fertighaus/components/ClientOnly/ClientOnly'

import { SECTION_NAV_HEIGHT } from '../../HouseSections/HouseSectionsNavigation'
import { Section } from './section'

export const StickySidebar = () => {
  const {
    state: { active }
  } = useHouseDetail()

  return (
    <SidebarBox>
      <StickyContainer>
        <SectionContainer>
          <Section.Price />
          <Section.Button />
          <Section.Footer />
        </SectionContainer>

        <Section.Vendor />

        {active && (
          <ClientOnly>
            <Section.SalesAgent />
          </ClientOnly>
        )}
      </StickyContainer>
    </SidebarBox>
  )
}

const SidebarBox = styled(Box)`
  grid-area: sidebar;
  display: block;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
  label: SidebarContainer;
`

const OFFSET_FROM_SECTION_NAV = 32

const StickyContainer = styled(Box)`
  position: sticky;
  top: ${SECTION_NAV_HEIGHT + OFFSET_FROM_SECTION_NAV}px;
  display: grid;
  grid-template-areas: 'sidebar-price' 'sidebar-button' 'sidebar-footer';
  label: StickyContainer;
`

const SectionContainer = styled(Box)`
  padding: ${({ theme }) => theme.spacing(2)};
  border-radius: var(--border-radius-card-large);
  box-shadow: ${shadow.actionCard};
  label: SectionContainer;
`
